// Menu를 사용하지 않는 이유는 차후에 메뉴 우측에 카운트를 표시하는 기능을 구현해야함
import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { Button, Space, Typography } from 'antd';
// import { StarOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
//----------------------------------------------------------------------------------------------------
const { Text, Link } = Typography;
//----------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------

/**
 * Sidebar Menu
 * @author
 * */
const SidebarMenu = (props) => {
  const { items, checkedIdx, navigate } = props;
  const location = useLocation();

  return (
    <>
      {items &&
        _.isArray(items) &&
        items
          .filter((v) => v.type != 'page') // type이 page인 것은 제외
          .map((item, idx) => {
            const keyIndex = idx + 1;
            //----------------------------------------------------------------------------------------------------
            // 최상위 경로가 같은 경우 선택상태 : 메뉴구조마다 다름
            let selected = 1;
            const pathname = `/${String(location.pathname).split('/')[1]}`;
            if (item.path == pathname) {
              selected = keyIndex;
            }
            //----------------------------------------------------------------------------------------------------
            if (item.type == 'section') {
              return (
                <div
                  key={keyIndex}
                  style={{
                    display: 'flex',
                    width: '100%',
                    height: '4.4rem',
                    backgroundImage: `url('${item.icon}')`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                  }}
                />
              );
            }
            return (
              <Button
                key={keyIndex}
                type="text"
                icon={item.icon(keyIndex == selected)}
                onClick={(e) => {
                  item.onClick({ navigate, path: item.path });
                }}
                style={{
                  marginTop: keyIndex == 1 ? '0' : '0.2rem',
                  display: 'flex',
                  width: '100%',
                  height: '4.4rem',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  border: 0,
                  background:
                    keyIndex == selected
                      ? `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`
                      : `transparent`,
                  // ...item.style,
                }}
              >
                <Text
                  style={{
                    width: '50%',
                    color: keyIndex == location ? '#FFF' : '#4B465C',
                    textAlign: 'start',
                    alignItem: 'center',
                  }}
                >{`${item.title}`}</Text>
                <div style={{ width: '30%', color: '#FFF' }}>{item.right}</div>
              </Button>
            );
          })}
    </>
  );
};

export default SidebarMenu;
